import { Box, Chip, Tooltip, Typography } from "@mui/material";

import type { SkillRow } from "./skillsGridColumns";

import { SkillOwnerIcon } from "../Chat/skills/SkillOwnerIcon";
import { SKILL_OWNER_TOKENS, skillOwner } from "../SkillAccess/skillAccessTokens";

/** Slash-style primary cell: owner icon, name, description, and optional disabled chip. */
export function SkillNameCell({ skill }: { skill: SkillRow }) {
  const owner = skillOwner(skill);
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        minWidth: 0,
        width: "100%",
        height: "100%",
      }}
    >
      <Tooltip title={SKILL_OWNER_TOKENS[owner].label} placement="left" disableInteractive>
        <Box
          component="span"
          sx={{ display: "flex", color: "action.active", flexShrink: 0 }}
          aria-label={SKILL_OWNER_TOKENS[owner].label}
          role="img"
        >
          <SkillOwnerIcon owner={owner} size={16} />
        </Box>
      </Tooltip>
      <Box sx={{ minWidth: 0, flexGrow: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }} noWrap>
          {skill.displayName}
        </Typography>
        <Typography variant="caption" color="text.secondary" noWrap component="div">
          {skill.description}
        </Typography>
      </Box>
      {skill.enabled ? null : (
        <Chip size="small" variant="outlined" label="disabled" sx={{ flexShrink: 0 }} />
      )}
    </Box>
  );
}
